import React, { useContext } from "react";

import { observer } from "mobx-react-lite";

import MealPlanFormStore from "./store/MealPlanFormStore";

interface Props {
  index: number;
}

export const Step: React.FC<Props> = observer(({ index, children }) => {
  const store = useContext(MealPlanFormStore.Context);

  if (store.currentStep !== index) return null;
  return <>{children}</>;
});

export default Step;
